var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01138 15.057C7.122 15.2154 7.30596 15.3079 7.5 15.3079C7.69402 15.3079 7.87799 15.2154 7.98862 15.057C8.31648 14.5877 8.69699 14.079 9.09796 13.5429C9.95493 12.3972 10.9054 11.1265 11.6352 9.84792C12.4955 8.34101 12.9234 7.0394 12.9234 5.875C12.9234 3.01049 10.4839 0.692102 7.5 0.692102C4.51606 0.692102 2.07656 3.01049 2.07656 5.875C2.07656 7.0394 2.50454 8.34101 3.36476 9.84792C4.09432 11.126 5.04636 12.3989 5.90369 13.5451C6.30441 14.0809 6.68443 14.589 7.01138 15.057ZM7.5 1.83092C9.84698 1.83092 11.7445 3.65175 11.7445 5.875C11.7445 6.82203 11.3784 7.93931 10.6029 9.29791C9.90803 10.5152 8.98893 11.7439 8.14608 12.8706C7.92356 13.1681 7.70636 13.4585 7.5 13.7396C7.29367 13.4585 7.07649 13.1682 6.85398 12.8707C6.01117 11.744 5.09201 10.5153 4.3971 9.29791C3.62155 7.93931 3.25547 6.82203 3.25547 5.875C3.25547 3.65175 5.15302 1.83092 7.5 1.83092Z",
    fill: "#7B788A",
    stroke: "#7B788A",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.54145C9.03005 8.54145 10.2867 7.35193 10.2867 5.875C10.2867 4.39806 9.03005 3.20855 7.5 3.20855C5.96995 3.20855 4.71328 4.39806 4.71328 5.875C4.71328 7.35193 5.96995 8.54145 7.5 8.54145ZM7.5 4.34737C8.39309 4.34737 9.10781 5.03932 9.10781 5.875C9.10781 6.71068 8.39309 7.40263 7.5 7.40263C6.60691 7.40263 5.89219 6.71068 5.89219 5.875C5.89219 5.03932 6.60691 4.34737 7.5 4.34737Z",
    fill: "#7B788A",
    stroke: "#7B788A",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.be5e32141be3a4b4889f6c057eda934e.svg";
export { ForwardRef as ReactComponent };